
<div class="screen-booking">
  <div class="popup-aside-plain">
    <div class="popup-takeResa">
      <div style="text-align:center">{{ getAllInfos.restoName }}</div>
      <div style="font-weight:100; font-size:14px">
        <div style="text-align:center">{{ getAllInfos.restoAdresse }}</div>
        <div style="text-align:center"><a :href="'tel:' + getAllInfos.restoTel">{{ getAllInfos.restoTel }}</a></div>
      </div>
    </div>
    <div class="success-container" v-loading="loading">
      <el-row :class="'black-inputs'">
        <el-col :span="18" :offset="3">
          Les informations CB sont validées.<br>
          <div>Vous allez être redirigé vers l'application automatiquement</div>
          <div>si ce n'est pas le cas cliquez <a :href="link">ici</a></div>
          <br>
          <div></div>
        </el-col>
      </el-row>
    </div>
  </div>
</div>
